/* ==========================================================================
   Internal Protected Route
   Task F33: Auth guard for internal (super-admin) pages
   ========================================================================== */

import { Navigate } from 'react-router-dom'
import { getInternalToken, isInternalTokenExpired } from '@/api/internal'

interface InternalProtectedRouteProps {
  children: React.ReactNode
}

export function InternalProtectedRoute({ children }: InternalProtectedRouteProps) {
  const token = getInternalToken()

  if (!token || isInternalTokenExpired()) {
    return <Navigate to="/internal/login" replace />
  }

  return <>{children}</>
}

export default InternalProtectedRoute
